import React from "react";
const ProgressBar = (props) => {
    return (
        <>
            {props.showprogress ? <div className="fixed bottom-0 z-20 w-[100%] p-3 bg-bgprogress font-bold text-left">{props.progresstxt}</div> : <></>}
        </>
    )
}

export default ProgressBar;